const GO_LIVE_BUTTON_CLASSES = [
  'h-11',
  'dark:[&>svg]:fill-black',
  'relative',
  '[&>svg]:h-6',
  '[&>svg]:w-6',
  'space-x-1',
  'rounded-3xl'
];

export { GO_LIVE_BUTTON_CLASSES };
